import React, { useState, useEffect } from "react"
import { useSelector } from "react-redux"
import { updateJobService } from "requesters/jobServiceRequester"
import { getBaseUrl } from "../../../../reducers"
import { BOUNDARY_ISSUE_LABELS } from "utils/constants"

const BOUNDARY_ISSUE_OPTIONS = [
  { value: "", label: "Please select one of the below" },
  ...Object.entries(BOUNDARY_ISSUE_LABELS).map(([value, label]) => ({ value, label }))
]

const DEFAULT_BOUNDARY_ISSUE_TYPE = ""

const BoundaryIssueSelection = ({ jobService, reloadData }) => {
  const baseUrl = useSelector(getBaseUrl)
  const {
    id,
    attributes: {
      boundaryIssueType
    }
  } = jobService

  const [selectedType, setSelectedType] = useState(boundaryIssueType || DEFAULT_BOUNDARY_ISSUE_TYPE)
  const [isSaving, setIsSaving] = useState(false)

  useEffect(() => {
    // Only set to empty string if no value exists, otherwise use existing value
    const currentType = boundaryIssueType || DEFAULT_BOUNDARY_ISSUE_TYPE
    setSelectedType(currentType)
  }, [boundaryIssueType])

  const handleTypeChange = async (e) => {
    const newType = e.target.value
    setSelectedType(newType)
    setIsSaving(true)

    try {
      // Send null when empty string is selected to clear the database value
      const valueToSend = newType === "" ? null : newType
      const { response, error } = await updateJobService(baseUrl, id, { boundary_issue_type: valueToSend })
      
      if (error) {
        console.error("Error updating boundary issue type:", error)
        // Revert the selection on error
        setSelectedType(boundaryIssueType || DEFAULT_BOUNDARY_ISSUE_TYPE)
      } else {
        // Reload data to get updated value
        reloadData()
      }
    } catch (error) {
      console.error("Error updating boundary issue type:", error)
      // Revert the selection on error
      setSelectedType(boundaryIssueType || DEFAULT_BOUNDARY_ISSUE_TYPE)
    } finally {
      setIsSaving(false)
    }
  }

  return (
    <div className="row py-3 border-top align-items-center">
      <div className="col-sm-12">
        <div className="mb-2">
          <label className="form-label mb-2"><strong>Boundary Issue Type</strong></label>
          <select
            className="form-control"
            value={selectedType}
            onChange={handleTypeChange}
            disabled={isSaving}>
            {BOUNDARY_ISSUE_OPTIONS.map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  )
}

export default BoundaryIssueSelection

